import request from "@/api/request"

export async function getCampaignDetail(id, isPreview) {
  const data = {
    campaignId: id,
    versionStatus: isPreview ? 'preview' : 'up'
  }

  const result = await request('get', '/project_guide_domain/campaign/detail', data)
  return result.msg
}

export async function getUniRouteConfig() {
  const date = new Date().getTime()
  const result = await request('get', `${process.env.VUE_APP_CDN_HOST}/consumer-uni-assets/uni_routes.json?t=${date}`)
  return result
}

export async function abTestApi(data) {
  let res = {
    featureName: data.featureName,
    disableIds: [],
    enableIds: []
  }
  res = await request('post', '/ab_test/which/mix', data)
  return res.msg
}
